import React from 'react'
import './_styles.scss'
import Utils from '../../../../../../../../../../../utils/Utils'
import Translator from '../../../../../../../../../../../requests/apa/Translator'
import store from '../../../../../../../../../../../store'
import { MODAL_MATCH_DETAIL, showModal } from '../../../../../../../../../../../actions/modal'

function ConDerechos (props) {
  var homeTeam = props.homeTeam || {}
  var awayTeam = props.awayTeam || {}

  const getTagLiveEvent = () => {
    const label = Translator.get('tag_envivo');

    if(label !== 'tag_envivo') return label;

    return Translator.get('Tag_EnVivo');
  }

  const openDetailMatch = (e) => {
    e.preventDefault()
    const { dateTime, id} = props

    const modalProps = {
      matchData: {
        matchId: id
      }
    }

    store.dispatch(showModal({
      modalType: MODAL_MATCH_DETAIL,
      modalProps
    }))
  }

  return (
    <a className='mc-cd match-card focusable' tabIndex={0} onClick={openDetailMatch}>
      <div className='mc-cd__band'>
        <div className='mc-cd__band mc-cd__band--home' style={{ background: homeTeam.color }} />
        <div className='mc-cd__band mc-cd__band--away' style={{ background: awayTeam.color }} />
      </div>


      <div className='mc-cd__live-group'>
        <p className='mc-cd__label'>
          <span>{Utils.cutPlayerString(Translator.get(`eventodeportivo_carruseletapas_ficha_texto_${props.status}`), 15)}</span>
          <span className='mc-cd__live-badge'>{Utils.cutPlayerString(getTagLiveEvent(), 7)}</span>
          <span className='mc-cd__live-min'>{props.liveTime}</span>
        </p>
      </div>

      <p className='mc-cd__comp-name'>{props.competition}</p>
      <p className='mc-cd__comp-group'>{props.competitionGroup}</p>

      <div className='mc-cd__sep' />

      <div className='mc-cd__flag mc-cd__flag--home'>
        <img src={homeTeam.flagUrl} alt={homeTeam.name} />
      </div>
      <p className='mc-cd__team-name mc-cd__team-name--home'>{homeTeam.name}</p>
      <p className='mc-cd__score mc-cd__score--home'>{props.homeScore}</p>

      <div className='mc-cd__flag mc-cd__flag--away'>
        <img src={awayTeam.flagUrl} alt={awayTeam.name} />
      </div>
      <p className='mc-cd__team-name mc-cd__team-name--away'>{awayTeam.name}</p>
      <p className='mc-cd__score mc-cd__score--away'>{props.awayScore}</p>
    </a>
  )
}

export default ConDerechos



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Paises/components/CountryDetailsModal/Components/CountryDetailsBody/Components/MatchCard/Components/ConDerechos/index.jsx